// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"4050974d","455":"8e19f7f2","973":"924f7f10","977":"1cd6fe67"}[chunkId] + ".chunk.js";
};